import { Dispatch, memo, SetStateAction } from 'react'
import { Formik, FormikHelpers } from 'formik'
import type { Options } from 'react-select'
import { HomeId } from '@racepointenergy/swc/scs/types'
import { ServiceState } from '@racepointenergy/swc/scs/features/host-states'
import { dealerConfigureServiceEvent } from '@racepointenergy/swc/scs/dealer-configure-service-event'

import type { DropdownOption } from 'components/Input/Dropdown'
import { getEventData } from '../utils'
import { HomeServicesEvent } from '../types'
import HomeServicesEventsForm from './HomeServicesEventsForm'
import { useAppDispatch } from 'app/hooks'

const initialServiceEventData: HomeServicesEvent = {
  zone: undefined,
  serviceId: undefined,
  event: undefined,
  serviceType: undefined,
  arguments: [
    {
      name: '',
      label: '',
    },
  ],
}

interface HomeServicesEventsProps {
  homeId: HomeId
  selectedTableService?: HomeServicesEvent
  services: ServiceState[]
  setZoneFilter: Dispatch<SetStateAction<DropdownOption | undefined>>
  setServiceTypeFilter: Dispatch<SetStateAction<DropdownOption | undefined>>
  setServiceIdFilter: Dispatch<SetStateAction<DropdownOption | undefined>>
  zonesDropdownOptions: Options<DropdownOption>
  servicesDropdownOptions: Options<DropdownOption>
  typesDropdownOptions: Options<DropdownOption>
}

function HomeServicesEvents({
  homeId,
  selectedTableService,
  services,
  setZoneFilter,
  setServiceTypeFilter,
  setServiceIdFilter,
  zonesDropdownOptions,
  servicesDropdownOptions,
  typesDropdownOptions,
}: HomeServicesEventsProps) {
  const dispatch = useAppDispatch()

  const handleSubmit = async (
    values: HomeServicesEvent,
    { setSubmitting, setStatus }: FormikHelpers<HomeServicesEvent>
  ) => {
    try {
      setSubmitting(true)
      const eventData = getEventData(homeId, values, services)
      await dispatch(dealerConfigureServiceEvent.initiate(eventData))
      setStatus({ success: true, error: false })

      setTimeout(() => {
        setStatus({ success: false, error: false })
      }, 1000)
    } catch (e) {
      console.log('Error submitting the service event', e)
      setStatus({ success: false, error: true })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Formik
      initialValues={initialServiceEventData}
      onSubmit={handleSubmit}
      initialStatus={{ success: false, error: false }}
    >
      {(formikProps) => (
        <HomeServicesEventsForm
          formikProps={formikProps}
          selectedTableService={selectedTableService}
          setZoneFilter={setZoneFilter}
          setServiceTypeFilter={setServiceTypeFilter}
          setServiceIdFilter={setServiceIdFilter}
          zonesDropdownOptions={zonesDropdownOptions}
          servicesDropdownOptions={servicesDropdownOptions}
          typesDropdownOptions={typesDropdownOptions}
        />
      )}
    </Formik>
  )
}

export default memo(HomeServicesEvents)
